import React from 'react';
import {
	Box,
	Button,
	Card,
	CardContent,
	CardHeader,
	makeStyles,
	Typography,
} from '@material-ui/core';
import { useHistory, useParams } from 'react-router';
import layoutService from 'src/services/layoutService';
import DetailItem from '../components/detailItem';

const status = {
	OPEN: {
		label: 'APERTO',
		color: 'success'
	},
	CLOSE: {
		label: 'CESSATO',
		color: 'error'
	},
}

const useStyles = makeStyles(theme => ({
	container: {
		paddingBottom: `${theme.spacing(1)}px !important`,

		'& div:last-child': {
			borderBottom: 0
		}
	},
	customItem: {
		borderBottom: `1px solid ${theme.palette.divider}`,
	},
	fontWeightMedium: {
		fontWeight: theme.typography.fontWeightMedium
	}
}));

function BillingSection({ contractLine, ...rest }) {
	const classes = useStyles();
	const history = useHistory();
	const { contractLineId } = useParams();
	const { entity } = history.location.state;
	const contract = contractLine?.contract;

	function handleEdit() {
		if(layoutService.isMobile())
			history.push('/mobile/supply/contract/edit/billing', { contractLine });
		else 
			history.push(`/app/supply/${contractLineId}/contract/edit/billing`, { entity, contractLine })
	}

	return (
		<Card {...rest}>
			<CardHeader title="Dati di Fatturazione" />
			<CardContent className={classes.container}>
				<DetailItem
					title="Tipo Fattura"
					value={contract?.reportDetailType?.name}
				/>
				<DetailItem
					title="Tipo Spedizione"
					value={contract?.deliveryMethod?.name}
				/>

				{contract?.deliveryMethod?.id === 'EMAIL' && (
					<>
						<DetailItem
							title="Email"
							value={contract?.customer?.deliveryEmail}
						/>
						<DetailItem
							title="Email Secondaria"
							value={contract?.customer?.deliveryEmailCC}
						/>
					</>
				)}

				{contract?.deliveryMethod?.id === 'PEC' && (
					<>
						<DetailItem
							title="PEC"
							value={contractLine?.contract?.customer?.deliveryPec}
						/>
						<DetailItem
							title="PEC Secondaria"
							value={contractLine?.contract?.customer?.deliveryPecCC}
						/>
					</>
				)}

				{(contract?.deliveryMethod?.id === 'PORDINARIA' ||
					contract?.deliveryMethod?.id === 'PRACCOMANDATA') && (
					<DetailItem
						title="Sede di Spedizione"
						value={
							contract?.customer?.deliveryPlaceAddressAsGoogle ||
							contract?.customer?.legalPlaceAddressAsGoogle
						}
					/>
				)}

				<Box mt={3} mb={1}>
					{contractLine?.updatable ? (
						<Button
							fullWidth
							variant="contained"
							color="secondary"
							onClick={handleEdit}
						>
							Modifica
						</Button>
					) : (
						<Typography variant="subtitle2" color="error" align="center">
							Per cambiare i dati relativi alla spedizione contatti il
							Callcenter
						</Typography>
					)}
				</Box>
			</CardContent>
		</Card>
	);
}

export default BillingSection;